module.exports = __webpack_public_path__ + "img/MG.ce040b27.svg";